import { useQuery } from '@tanstack/react-query';
import { apiGet, qk } from './_client';

/** GET /api/films/{id}/cast — film cast roster. */
export function useFilmCast(filmId, options = {}) {
  const { enabled, ...rest } = options;
  return useQuery({
    queryKey: qk.filmCast(filmId),
    queryFn: ({ signal }) => apiGet(`/films/${filmId}/cast`, signal),
    enabled: !!filmId && (enabled ?? true),
    ...rest,
  });
}
